import React from 'react';
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../reducers";
import {Navigate, Route, Routes} from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import {getStoreConfig, getStoreDefaultConfig} from "../../services/Store/reducer";
import Footer from "../../components/layout/Footer/Footer";
import ErrorOrderModal from "../HomePage/components/ErrorOrderModal";
import CartPage from "../Cart/CartPage";
import RulesPage from "../Rules/RulesPage";
import LoginLayout from "../Login/LoginLayout";
import SummaryPage from "../Summary/SummaryPage";
import OrderTypeLayout from "../OrderType/OrderTypeLayout";
import DeliveryOrderTypePage from "../OrderType/DeliveryOrderTypePage";
import DineInOrderTypePage from "../OrderType/DineInOrderTypePage";
import RoomServiceOrderTypePage from "../OrderType/RoomServiceOrderTypePage";
import PickUpOrderTypePage from "../OrderType/PickUpOrderTypePage";
import StoreUtils from "../../services/Store/StoreUtils";
import HomePage from "../HomePage/HomePage";
import {getOrderValid} from "../../services/Cart/reducer";
import DynamicPage from "../Page/DynamicPage";
import {getLanguagesBasedOnStoreType} from "../../services/languageUtils";
import TableOrderPage from "../TableOrder/TableOrderPage";
import {MainNavStickyProvider} from "./MainNavStickyContext";
import VoucherProductsProvider from "../../services/VoucherProducts/VoucherProductsContext";
import MenuSearchProvider from "../../services/Menu/services/Search/MenuSearchContext";
import MenuPage from "../Menu/pages/MenuPage";
import {useTranslation} from "react-i18next";

type Props = ReturnType<typeof mapStateToProps> & DispatchProp;

const SingleStoreContextComponent = ({orderValid, config, defaultConfig}: Props) => {
    const {t} = useTranslation();

    if (config === undefined) return null;

    const navbarBackTitle = t("common.word.menu");
    const navbarBackUrl = "/";
    const isMultilevelMenu = StoreUtils.isMultilevelMenu(config);

    const drawMenuRoutes = (isHomepageMenu?: boolean) => {
        if (isMultilevelMenu) {
            return (
                <>
                    <Route path={isHomepageMenu ? "menu/:menuId/*" : ":menuId/*"} element={<MenuPage/>}/>
                    <Route path={`*`} element={<MenuPage/>}/>
                </>
            )
        }

        return (
            <>
                <Route path={`menu/:menuId`} element={<Navigate to="/" replace/>}/>
                <Route path={`*`} element={<MenuPage/>}/>
            </>
        )
    }

    return (
        <MainNavStickyProvider>
            <VoucherProductsProvider isMultilevelMenu={isMultilevelMenu}>
                <MenuSearchProvider>
                    {!orderValid && (
                        <ErrorOrderModal/>
                    )}
                    <Routes>
                        <Route path={`cart`} element={<CartPage/>}/>
                        <Route path={`rules`} element={<RulesPage config={config}/>}/>
                        <Route path={`login/*`} element={<LoginLayout/>}/>
                        <Route path={`summary/:id/:token`} element={<SummaryPage/>}/>
                        <Route path={`DELIVERY`}
                               element={<OrderTypeLayout><DeliveryOrderTypePage/></OrderTypeLayout>}/>
                        <Route path={`DINE_IN`}
                               element={<OrderTypeLayout><DineInOrderTypePage/></OrderTypeLayout>}/>
                        <Route path={`ROOM_SERVICE`}
                               element={<OrderTypeLayout><RoomServiceOrderTypePage/></OrderTypeLayout>}/>
                        <Route path={`PICK_UP`}
                               element={<OrderTypeLayout><PickUpOrderTypePage/></OrderTypeLayout>}/>
                        <Route path={`/:slug`} element={<DynamicPage/>}/>
                        {StoreUtils.isMultistore(defaultConfig) ? (
                            <Route path={`*`} element={<>
                                <Navbar navbarBackTitle={navbarBackTitle} navbarBackUrl={navbarBackUrl}/>
                                <Routes>
                                    {drawMenuRoutes(StoreUtils.isHomepageMenu(config))}
                                </Routes>
                                <div className={"body-container-cart"}>
                                    <Footer config={config}
                                            languages={getLanguagesBasedOnStoreType(defaultConfig)}/>
                                </div>
                            </>}/>
                        ) : (
                            <>
                                {StoreUtils.isHomepageMenu(config) ? (
                                    <>
                                        <Route path={`*`} element={<>
                                            <Navbar navbarBackTitle={navbarBackTitle} navbarBackUrl={navbarBackUrl}/>
                                            <Routes>
                                                {drawMenuRoutes(true)}
                                            </Routes>
                                            <div className={"body-container-cart"}>
                                                <Footer config={config}
                                                        languages={getLanguagesBasedOnStoreType(defaultConfig)}/>
                                            </div>
                                        </>}/>
                                    </>
                                ) : (
                                    <>
                                        <Route path={`menu/*`} element={<>
                                            <Navbar navbarBackTitle={navbarBackTitle} navbarBackUrl={navbarBackUrl}/>
                                            <Routes>
                                                {drawMenuRoutes()}
                                            </Routes>
                                            <div className={"body-container-cart"}>
                                                <Footer config={config}
                                                        languages={getLanguagesBasedOnStoreType(defaultConfig)}/>
                                            </div>
                                        </>}/>
                                        <Route path={`table_order/:orderUrl`} element={<TableOrderPage/>}/>
                                        <Route path={`*`} element={<HomePage/>}/>
                                    </>
                                )}
                            </>
                        )}
                    </Routes>
                </MenuSearchProvider>
            </VoucherProductsProvider>
        </MainNavStickyProvider>
    )
}

const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
    defaultConfig: getStoreDefaultConfig(state.config),
    orderValid: getOrderValid(state.cart),
})

const connector = connect(mapStateToProps);
export default connector(SingleStoreContextComponent);